export default "__VITE_ASSET__Bqr7PkLB__"